// The right-hand panel is a stack of sections, each named by one plain heading and ruled off from
// the next, so the eye reads it top to bottom as statement, page, then changes.
export const PANEL_SECTION = 'flex flex-col gap-4 p-4'

export const PANEL_HEADING = 'text-[13px] font-medium leading-5 text-foreground'
